import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
import image1 from "assets/img/01dec1918.png";
import image101 from "assets/img/02dec1918.png";
// import image102 from "assets/img/14122018-2.png";
// import imageIso from "assets/img/27000family.png";

class ProductSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    // const { expanded } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center" style={{ textAlign: "left", color: "black" }}>
            <GridItem xs={12} sm={12} md={10}>
              <Card>
                <CardBody>
                  <span style={{ marginBottom: 0 }}>19 Desember 2018, 08.00 PM</span>
                  <h2 style={{ color: "#4BB64B", marginTop: 0 }}><b>In House Training: Audit Internal dan Kaji Ulang Manajemen ISO 9001:2015</b></h2>
                  <span style={{ fontSize: 18 }}>
                    <br />
                    <center>
                      <img src={image1} alt="Images" style={{ width: 520, height: 390, marginRight: 25 }} />
                    </center> <br /><br />
                    <p style={{ fontSize: 18 }}>
                      PT. Sandton Sukses Bersama mendapat kepercayaan dari Dinas Peternakan dan Kesehatan Hewan Provinsi Jawa Tengah untuk melaksanakan In House Training dengan tema “Audit Internal dan Kaji Ulang Manajemen ISO 9001:2015”, bertempat di Boyolali pada tanggal 14 Mei 2018. Peserta training yang ikut serta adalah staff dan veterinarian dari Balai Veteriner Boyolali.
                    </p><br />
                    <center>
                      <img src={image101} alt="Images" style={{ width: 500, height: 350, marginRight: 25 }} />
                    </center> <br /><br />
                    <p style={{ fontSize: 18 }}>
                      Tujuan pelaksanaan training ini adalah untuk menyegarkan kembali pengetahuan para staff tentang audit internal dan sistem manajemen mutu ISO 9001:2015 yang sudah berjalan dalam lingkungan kerja mereka.
                    </p>
                    <p style={{ fontSize: 18 }}>
                      Dimana dalam standar sistem manajemen mutu (SMM) internasional ISO 9001:2015 terdapat 7 prinsip yang dikenal dengan sebutan jembatan keledai “CLEPIER” (customer, leadership, engagement, process, improvement, evidence, relationship). Tujuh prinsip manajemen mutu ini yang dapat diterapkan manajemen senior untuk mendorong peningkatan organisasi:
                    </p>
                    <ol>
                      <b><li>Fokus pada Pelanggan <i>(Customer Focus)</i></li></b>
                    Merupakan cara yang dilakukan oleh perusahaan untuk dapat melayani pelanggan dengan baik sehingga dapat memenuhi harapan pelangan, mempertahankan kepercayaan dan kepuasan pelanggan.
                      <b><li>Kepemimpinan <i>(Leadership)</i></li></b>
                    Setiap pemimpin yang terdapat dalam perusahaan harus mampu mengarahkan, menetapkan sasaran perusahaan dan mengkomunikasikan ke seluruh organisasi sehingga sistem dapat berjalan dengan baik dan berkembang sesuai dengan tujuan perusahaan.
                      <b><li>Keterlibatan Orang <i>(Engagement of people)</i></li></b>
                    Pemberdayaan dan peningkatan ketrampilan bertujuan agar perusahaan memiliki individu yang kompeten sehingga dapat menjalankan sistem dengan baik agar dapat mencapai tujuan organisai dan memberikan nilai lebih untuk pelanggan.
                      <b><li>Pendekatan Proses <i>(Process Approach)</i></li></b>
                    Sistem manajemen mutu terdiri atas proses yang saling terkait. Termasuk semua proses, sumber daya, pengendalian, dan interaksi agar memungkinkan pengoptimalan kinerja perusahaan sehingga semua bagian dapat bersinergi secara bersama – sama
                      <b><li>Perbaikan <i>(Improvement)</i></li></b>
                    Perusahaan yang sukses dan mampu bertahan dalam persaingan adalah Perusahaan yang fokus untuk selalu melakukan perubahan melalui peningakatan berkelanjutan baik internal dan eksternal yang disesuaikan dengan perkembangan jaman. Sehingga perusahaan dapat menciptakan peluang baru dan selalu siap menghadapi persaingan dengan para kompetitor.
                      <b><li>Pengambilan Keputusan Berbasis Bukti <i>(Evidence-based decision making)</i></li></b>
                    Setiap pengambilan keputusan terhadap setiap masalah yang timbul didalam perusahaan harus berdasarkan fakta dan bukti – bukti yang ada dan kuat serta terdokumentasi. Fakta, bukti, dan analisis data meningkatkan objektivitas dan kepercayaan dalam pengambilan keputusan. Sehingga keputusan yang diambil akan menghasilkan keputusan yang produktif dan tepat sasaran.
                      <b><li>Manajemen Hubungan <i>(Relationship Management)</i></li></b>
                    Perusahaan harus mengelola hubungannya dengan pihak-pihak yang berkepentingan (interested parties) diantaranya adalah para pemasoknya, mitra kerja, karyawan, pemerintah, masyarakat, dan lainnya. Tujuannya supaya mencapai kesuksesan yang berkesinambungan dan agar organisasi dengan mudah mendapatkan rekan kerja untuk mendukung tercapainya kepuasan pelanggan.
                    </ol>
                  <p style={{ fontSize: 18 }}>
                    Karena dengan melaksanakan 7 prinsip standar sistem manajemen mutu ISO 9001 tersebut menjadikan organisasi dengan pelayanan yang prima sesuai harapan dan kebutuhan masyarakat yang menggunakan jasa Balai Veteriner Boyolali.
                    </p>
                  <p style={{ fontSize: 18 }}>
                    Terima kasih kepada Dinas Peternakan dan Kesehatan Hewan Provinsi Jawa Tengah dan staff Balai Veteriner Boyolali yang telah percaya kepada kami PT. Sandton Sukses Bersama sesuai dengan motto perusahaan kami <b>“Inspiring World Quality System”</b> .
                    </p>
                  <br />
                  </span>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
      </div>
      </div >
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/News/Sections/ProductSection.4.jsx